import axios from "axios";
import { FETCH_ALL_TYPE_API } from "../Constants/Apis";

export const getTypes = async () => {
  try {
    return axios.get(FETCH_ALL_TYPE_API);
  } catch (e) {
    return console.log(e);
  }
};

export const createType = async (payload) => {
  try {
    return axios.post(FETCH_ALL_TYPE_API, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const updateType = async (id, payload) => {
  try {
    return axios.put(`${FETCH_ALL_TYPE_API}/${id}`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const deleteType = async (id) => {
  try {
    return axios.delete(`${FETCH_ALL_TYPE_API}/${id}`);
  } catch (e) {
    return console.log(e);
  }
};

